export const COLUMNS_SIZE = "2fr 1fr 1fr";
